import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-empresa',
  templateUrl: './portal-empresa.component.html',
  styleUrls: ['./portal-empresa.component.css']
})
export class PortalEmpresaComponent implements OnInit{

  public breadcrumb: any;
  currentOrientation = 'horizontal';
  start: any;
  end: any;

  constructor() { }

  ngOnInit() {
    this.breadcrumb = {
      'mainlabel': 'Ofertador Empresa'
    };

  }
}
